declare namespace $ {

	export class $mol_icon_backspace_outline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=outline.view.tree.d.ts.map